import React from 'react'
import { Link } from 'react-router-dom';
import Dog from 'services/Dog';
import RegistrationRequest from 'services/RegistrationRequest';
import Show from 'services/Show';
import { formatDate } from 'services/utils';

import DogForm                   from 'components/DogForm';
import DogAddToShows             from 'components/DogAddToShows';
import { Spinner, RequestState } from 'components/atoms';
import RemoveButton              from 'components/RemoveButton';
import RequestDocuments          from 'components/RequestDocuments';

export default class RegistrationRequestProcess extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      item: null,
      dog: null,
      dogs: null,
      dogSearchFinished: false,
      openShows: null,
      itemId: match.params.id,
    }
    this.itemClass = RegistrationRequest;
    this.mounted = false
  }

  componentDidMount() {
    this.mounted = true;
    this.loadItem();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  itemChanged = (item = this.state.item) => {
    this.setState({ item });
  }

  loadItem = () => {
    this.setState({loading: true});
    this.itemClass.get(this.state.itemId).then((item) => {
      if (!this.mounted) return false;
      if (!item.register_to) {
        item.register_to = [];
      }
      if (!item.register_to.push) {
        item.register_to = Object.values(item.register_to)
      }
      item.register_to = item.register_to
        .filter(rdata => rdata.class_in_show && rdata.submitted !== 'false' && rdata.submitted !== false)
        .map(rdata => {
          delete(rdata.submitted);
          if (!rdata.titles) {
            rdata.titles = '';
          }
          return rdata;
        });
      
      this.findDog(item);
      this.setState({ item });
      this.loadOpenShows();
    }).catch(alert).then(() => this.setState({loading: false}) );
  }

  loadOpenShows() {
    Show.query({is_open: true, order: 'byStartsAtUp'}).then(result => {
      if (!this.mounted) return false;
      this.setState({
        openShows: result.items
      });
    });
  }

  findDog(item) {
    if (item.dog && item.dog.id) {
      const dog = new Dog(item.dog);
      this.setState({
        dogSearchFinished: true,
        dog
      });
    }
    Dog.query({pedigree: item.pedigree, full_data: true}).then(result => {
      if (!this.mounted) return false;
      let dog, dogs = null;
      if (result.items && result.items[0]) {
        dog = result.items[0];
        dog.request_id = this.state.item.id;
        dog.registerTo = item.register_to.map(rdata => {
          if (!rdata.titles) rdata.titles = '';
          return rdata;
        });
        dog.request_id = item.id;
        if (result.items.length) {
          dogs = result.items;
        }
      } else {
        dog = new Dog();
      }
      this.setState({
        dogSearchFinished: true,
        dog: dog,
        dogs: dogs,
      });
    }); 
  }

  itemChanged = (item = this.state.item) => {
    this.setState({ item });
  }

  dogChanged = (dog = this.state.dog) => {
    // on dog save
    this.setState({ dog });
    this.loadItem();
  }

  copyRequestToDog = () => {
    const item = this.state.item;
    const dogData = {...item};
    dogData.registerTo = [...item.register_to];
    dogData.request_id = dogData.id;
    dogData.id = null;
    delete(dogData.shows);
    delete(dogData.data);
    const dog = new Dog(dogData);
    this.setState({ dog });
  }

  clearDog = () => {
    const dog = new Dog();
    this.setState({ dog });
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  removeItem = () => {
    const item = this.state.item;
    if (!item) return;
    this.setState({loading: true});
    item.delete().then((id) => {
      this.props.history.goBack();
    }).catch(console.error).then(() => {
      this.setState({loading: false});
    });
  }

  renderDogs() {
    const {dog, dogs} = this.state;
    let dogsList;
    if (dogs) {
      dogsList = (
        <div className="row" key="dogsList">
          <h3 className="col-12">Найдены совпадения в базе</h3>
          <ul>
            { dogs.map(dog => <li key={dog.id}>
              <Link to={`/dogs/${dog.id}`} rel="noopener noreferrer" title="открыть в новом окне" target="_blank">
                {dog.name} - {dog.pedigree} - {formatDate(dog.date_of_birth)}
              </Link>
            </li> )}
          </ul>
        </div>
      );
    } else {
      dogsList = <div key="dogsList" className="reg-request_dogs-list">
        <button className="btn btn-info btn-sm float-end" onClick={this.copyRequestToDog}>Создать из запроса</button>
        <h4>Совпадения в базе не найдены</h4>
      </div>
    }
    return [
      dogsList,
      (
        <div className="row" key="dogForm">
          <DogForm item={dog} onChange={this.dogChanged} onCancel={this.clearDog} />
          <DogAddToShows shows={dog.shows} registerTo={dog.registerTo} openShows={this.state.openShows} onChange={this.dogChanged} />
        </div>
      )
    ];
  }

  render() {
    const {item, openShows, dogSearchFinished, loading} = this.state;
    
    return (
      <div className="container-fluid">
        <h4>Запрос на регистрацию <RequestState item={item}/></h4>
        {item && 
          <div className="row">
            <div className="col-lg-6">
              <DogForm item={item} onChange={this.itemChanged} onCancel={this.onCancel} idPrefix="request">
                
                {openShows ? <DogAddToShows openShows={openShows} 
                                registerTo={item.register_to} 
                                onChange={this.itemChanged}
                                idPrefix="regToShow" />
                           : null}
              </DogForm>
              <h3>Документы</h3>
              <RequestDocuments item={item} />
              <Link to={`/registration-requests/${item.id}/print`} target="_blank" className="btn btn-info">Печать</Link>
              <RemoveButton className="btn-sm float-end ms-2" remove={this.removeItem} />
            </div>
            <div className="col-lg-6">
              {dogSearchFinished ? this.renderDogs() : <Spinner /> }
            </div>
          </div>
        }
        {loading && <Spinner /> }
      </div>
    );
  }

}


